/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorize-subscribe-type.vue?vue&type=template&id=cf844f04&"
import script from "./authorize-subscribe-type.vue?vue&type=script&lang=js&"
export * from "./authorize-subscribe-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports